var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantSmallIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.98 8.99c1.214 4.363-.186 8.89-4.082 12.25C16 24.621 9.608 26.838 5.292 24.18.976 21.542-1.264 13.982.742 8.523 2.75 3.04 9.003-.366 13.996.03c5.016.397 8.796 4.62 9.986 8.96z",
    fill: "#011E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai_assistant_small_ic_svg__clip0_1721_5227)",
    fill: "#B8EF36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.114 9.361h1.629v9.397h-1.63v-1.617c-.81 1.241-1.992 1.862-3.54 1.862-1.31 0-2.43-.48-3.354-1.438-.924-.958-1.386-2.127-1.386-3.504 0-1.378.462-2.547 1.386-3.506.925-.958 2.044-1.439 3.355-1.439 1.547 0 2.73.622 3.54 1.863V9.36zm-3.334 8.065c.95 0 1.743-.323 2.38-.969.636-.646.954-1.444.954-2.396s-.318-1.752-.955-2.396c-.636-.647-1.432-.97-2.379-.97-.947 0-1.723.323-2.36.97-.636.646-.956 1.446-.956 2.396s.318 1.752.956 2.396c.637.646 1.425.97 2.36.97zM17.48 8.533c-.313 0-.575-.107-.787-.32a1.043 1.043 0 01-.318-.769c0-.3.106-.56.318-.781.212-.219.474-.329.786-.329.313 0 .555.11.767.329.214.22.319.479.319.781 0 .302-.107.557-.319.77-.212.214-.467.319-.767.319zM18.284 9.361h-1.629v9.397h1.63V9.361z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai_assistant_small_ic_svg__clip0_1721_5227"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.833 6.334)",
    d: "M0 0h12.732v12.669H0z"
  })))));
}
export default SvgAiAssistantSmallIc;